import { render, staticRenderFns } from "./csr_pdf_dashboard.vue?vue&type=template&id=00d87657&scoped=true&"
import script from "./csr_pdf_dashboard.vue?vue&type=script&lang=js&"
export * from "./csr_pdf_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d87657",
  null
  
)

export default component.exports